import { UserTypeEnum } from '../../../types/enums/User';
import {
  CONSUMER_TERMS_EMEA_URL,
  PARTNER_PRO_TERMS_EMEA_URL,
  PERK_TERMS_GB_URL,
  PERK_TERMS_US_CA_URL,
  PRO_TERMS_GB_URL,
  PRO_TERMS_US_CA_URL,
} from '../../../config';
import React from 'react';
import NewTermsAndPerksLinks from './NewTermsAndPerksLinks';
import MiddleEastLinks from './MiddleEastLinks';
import ConsumerLinks from './ConsumerLinks';
import PartnerLinks from './PartnerLinks';

const Links = ({
  userType,
  viewTermsUrl,
  eulaUrl,
  privacyPolicy,
  middleEasternCountry,
  country,
  showPerks = true,
}) => {
  const isPartnerLike =
    userType === UserTypeEnum.PARTNER || userType === UserTypeEnum.DISTRIBUTOR;

  const shouldShowPerks = showPerks && userType === UserTypeEnum.PARTNER; // guard perks from distributor

  if (shouldShowPerks) {
    if (country === 'US' || country === 'CA') {
      return (
        <NewTermsAndPerksLinks
          proTermsUrl={PRO_TERMS_US_CA_URL}
          perkTermsUrl={PERK_TERMS_US_CA_URL}
        />
      );
    } else if (country === 'GB') {
      return (
        <NewTermsAndPerksLinks
          proTermsUrl={PRO_TERMS_GB_URL}
          perkTermsUrl={PERK_TERMS_GB_URL}
        />
      );
    }
  }
  return (
    <>
      {userType === UserTypeEnum.CONSUMER &&
        (middleEasternCountry ? (
          <MiddleEastLinks
            privacyPolicy={privacyPolicy}
            termsUrl={CONSUMER_TERMS_EMEA_URL}
          />
        ) : (
          <ConsumerLinks viewTermsUrl={viewTermsUrl} eulaUrl={eulaUrl} />
        ))}

      {isPartnerLike &&
        (middleEasternCountry ? (
          <MiddleEastLinks
            privacyPolicy={privacyPolicy}
            termsUrl={PARTNER_PRO_TERMS_EMEA_URL}
          />
        ) : (
          <PartnerLinks viewTermsUrl={viewTermsUrl} />
        ))}
    </>
  );
};

export default Links;
